import classNames from 'classnames'
import { NotesSection } from './Search'
import { UniversalItemRenderer } from '../../components/shared/BlockRenderer'
import { createSearchResultItem } from '../../components/shared/BlockRenderer/utils'

type Props = {
  section: NotesSection
  index: number
  handleRevealNote: (_recordName: string) => void
  keyword: string
}

export default function SectionComponent({
  section,
  index,
  handleRevealNote,
  keyword,
}: Props) {
  const blockCount = section.noteResults.reduce(
    (accumulator, noteResult) => accumulator + noteResult.blocks.length,
    0
  )
  return (
    <div key={index} className='p-3'>
      <h2
        className={classNames(
          'py-0.5 pl-3 text-xs font-semibold uppercase text-zinc-500 dark:text-zinc-400',
          section.teamSpaceId
            ? 'bg-green-200 dark:bg-green-950'
            : 'bg-zinc-100 dark:bg-zinc-900'
        )}
      >{`${section.title} (${blockCount.toString()})`}</h2>
      <div className='flex flex-col px-3'>
        {section.noteResults.map((noteResult, index) => (
          <div
            key={index}
            className='mt-5 border-t-2 border-zinc-100 py-1 dark:border-zinc-800'
          >
            <div className='flex items-start gap-2'>
              <i className='far fa-file-lines text-sm opacity-70'></i>
              <h3 className='text-sm font-semibold'>{noteResult.title}</h3>
            </div>
            <div className='flex flex-col'>
              {noteResult.blocks.map((result) => {
                const renderableItem = createSearchResultItem(result, keyword)

                return (
                  <UniversalItemRenderer
                    key={`${result.recordName}-${result.lineIndex.toString()}-${result.content}`}
                    item={renderableItem}
                    variant='search'
                    showTaskToggle={true}
                    className='search-result-item'
                  />
                )
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
